import React, { useEffect, useState } from "react";
import { stats } from "./mockdata/PatientData";
import StatCard from "../UI/StatCard";
import PatientsBreakdown from "../UI/PatientsBreakdown";
import PatientAdmission from "../UI/PatientAdmission";

import GenderDistribution from "../UI/GenderDistribution";
import OutAndInpatientGraph from "../UI/OutAndInpatientGraph";
import { get } from "../../utility/fetch";
import MainDashboard from "./MainDashboard";
import AddStaffPage from "./nurse/Nurse";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const navigate = useNavigate();
  const user = localStorage.getItem("name");
  const [assignedPatients, setAssignedPatients] = useState(0);
  const [outPatients, setOutpatients] = useState(0);
  const [waiting, setWaiting] = useState(0);
  const [admitted, setAdmitted] = useState(0);
  const [hmoPatients, setHmoPatients] = useState(0);
  const [gender, setGender] = useState({});
  const [summary, setSummary] = useState([0, 0, 0, 0, 0]);
  const [graph, setGraph] = useState({
    inPatientPercentage: 0,
    outPatientPercentage: 0,
    dailyAverageCount: [
      {
        date: "Mar 21",
        inPatientCount: 0,
        outPatientCount: 0,
      },
    ],
  });
  const [loading, setLoading] = useState(false);

  //done
  const getGraphDetails = async () => {
    try {
      const response = await fetch(
        "https://edogoverp.com/medicals/api/dashboard/AllOutPatientAndInPatientCount"
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log(data);
      setGraph(data);
    } catch (e) {
      console.log("Error: ", e);
    }
  };

  const getGender = async () => {
    try {
      const data = await get(`/dashboard-doctor/genders`);
      console.log(data);
      setGender(data);
    } catch (e) {
      console.log("Error: ", e);
    }
  };
  const getAssigned = async () => {
    try {
      const data = await get(`/dashboard/assignedtodoctor`);
      // const data = await get(`/dashboard-doctor/assignedtodoctor`);
      setAssignedPatients(data);
    } catch (e) {
      console.log("Error: ", e);
    }
  };

  const getOutPatients = async () => {
    try {
      const data = await get(
        `/dashboard-doctor/AllOutPatientAndInPatientCounts`
      );
      console.log("Outpatients: ", data);

      setOutpatients(data || 0);
    } catch (e) {
      console.log("Error: ", e);
      setOutpatients(0);
    }
  };

  const getWaiting = async () => {
    try {
      const data = await get(`/dashboard/assignedtodoctor`, { status: 2 });

      setWaiting(data);
    } catch (e) {
      console.log("Error: ", e);
    }
  };
  const getAdmitted = async () => {
    try {
      const data = await get(`/dashboard-doctor/doctors/admitted-patients`);

      setAdmitted(data);
    } catch (e) {
      console.log("Error: ", e);
    }
  };

  //done
  const getHmoPatients = async () => {
    try {
      const data = await get(`/dashboard-doctor/hmo-patients`);

      setHmoPatients(data);
    } catch (e) {
      console.log("Error: ", e);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    await getAssigned();
    await getAdmitted();
    await getHmoPatients();
    await getOutPatients();
    await getWaiting();
    // await getGraphDetails();
    await getGender();
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setSummary([assignedPatients, outPatients, waiting, admitted, hmoPatients]);
  }, [assignedPatients, outPatients, waiting, admitted, hmoPatients]);

  const handleStatClick = (stat) => {
    const cardname = stat.title || stat.name || stat.label || String(stat);
    navigate(`/doctor/patients?cardname=${encodeURIComponent(cardname)}`);
  };

  return (
    <div className="w-100 m-t-80">
      {loading ? (
        <div className="loader">loading ...</div>
      ) : (
        <div className="m-t-20">
          <MainDashboard
            assignedPatients={assignedPatients || 0}
            hmoPatients={hmoPatients || 0}
            outPatients={outPatients || 0}
            admitted={admitted || 0}
            gender={gender || []}
            onStatClick={handleStatClick} // Pass the handler down
          />
        </div>
      )}

      {/* <AddStaffPage/> */}
    </div>
  );
}

export default Dashboard;
